export enum TaskStatusEnum {
  'PENDING' = 'pending',
  'ACTIVE' = 'active',
  'FINISHED' = 'finished',
  'AUTO_ARCHIVED' = 'auto_archived',
}
